import { observable } from 'mobx';
import RootStore from './root-store';

export const SIDEBAR_SCREEN = {
  BATCH_FORM: 'batchForm',
  TEST_MODE: 'testMode',
  SCHEDULES: 'schedules',
  DEVICES: 'devices',
  EDITOR: 'editor',
  DIAGNOSE: 'diagnose',
  BATCH_MATERIAL: 'batch_material',
  WASHOUT: 'washout',
  ORDER_FORM: 'orderForm',
  BATCH_FINISH: 'batchFinish',
};

type SidebarType = typeof SIDEBAR_SCREEN[keyof typeof SIDEBAR_SCREEN];

class SidebarStore {
  rootStore: RootStore;
  @observable type: SidebarType|null = null;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }

  isOpen(type: SidebarType): boolean {
    return type === this.type;
  };

  onToggle(type: SidebarType|null): void {
    this.type = type === this.type ? null : type;
  };
}

export default SidebarStore;
